// src/components/ServiceCards/ServiceCards.jsx
import React from "react";
import { Link } from 'react-router-dom';
import { FaProjectDiagram, FaTools, FaHeadset, FaChalkboardTeacher } from "react-icons/fa";
import "./ServicesCardsHome.css";

function ServiceCard({ icon: Icon, title, subtitle }) {
  return (
    <div className="sc-card">
      <div className="sc-icon">
        <Icon size={28}  />
      </div>
      <h3>{title}</h3>
      {subtitle && <p className="sc-sub">{subtitle}</p>}
    </div>
  );
}

export default function ServiceCards() {
  const cards = [
    { title: "Etudes et Conceptions", subtitle: "Définir et proposer des solutions techniques optimales", icon: FaProjectDiagram },
    { title: "Supervision et Contrôle des travaux", subtitle: "Suivi rigoureux et gestion sur le terrain", icon: FaTools },
    { title: "Assistance à la Maîtrise d’Ouvrage", subtitle: "Support et accompagnement complet", icon: FaHeadset },
    { title: "Formation", subtitle: "Programmes adaptés à vos équipes", icon: FaChalkboardTeacher },
  ];

  return (
    <section className="service-cards">
      {cards.map((c, idx) => (
        <div key={idx} className="sc-card-link" aria-label={`Carte ${c.title}`}>
          <ServiceCard icon={c.icon} title={c.title} subtitle={c.subtitle} />
        </div>
      ))}
    </section>
  );
}
